import { StatusTag } from '@innovyze/stylovyze/lib/components';
import React from 'react';
import { EMPTY } from '@innovyze/stylovyze/lib/utils/constants';
export const Active = () => (React.createElement(StatusTag, { color: "positive", text: "ACTIVE", width: "100%" }));
export const Resolved = () => (React.createElement(StatusTag, { color: "neutral", text: "RESOLVED", width: "100%" }));
export default function getActiveStatusTag(status) {
    switch (status) {
        case 'open':
            return React.createElement(Active, null);
        case 'resolved':
            return React.createElement(Resolved, null);
        default:
            return EMPTY;
    }
}
